import * as React from 'react';
import { Field } from 'redux-form';

import { SegmentLabel } from '@acceligentllc/storybook';

import Textarea from 'af-fields/Textarea';

import JobUpsertFM from '../../formModel';
import { formSectionClass, formSectionClassColumn8, formSectionClassRow } from '../../helpers';

const WORK_SUMMARY_MAX_LENGTH = 600;

type Props = {
	isDisabled: boolean;
};

const SummaryOfWorkSection: React.FC<Props> = ({ isDisabled }) => {
	return (
		<div className={formSectionClass}>
			<div className={formSectionClassRow}>
				<SegmentLabel
					label="Summary of Work"
					tooltip="Job notes shown on the Work Order, visible to the worker on the WO Confirmation modal."
				/>
			</div>
			<div className={formSectionClassRow}>
				<div className={formSectionClassColumn8}>
					<Field
						component={Textarea}
						disabled={isDisabled}
						maxCharacters={WORK_SUMMARY_MAX_LENGTH}
						name={JobUpsertFM.getAttributeName('requestJobNote')}
						placeholder="Enter text"
						rows={4}
						showMaxCharactersLabel={true}
					/>
				</div>
			</div>
		</div>
	);
};

export default React.memo(SummaryOfWorkSection);
